/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.5
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * GlobalSearchApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseForSearchFilter } from '../model/course-for-search-filter';
import { GlobalSearchResult } from '../model/global-search-result';
import { appendQueryParam } from './query-params';

@Injectable({ providedIn: 'root' })
export class GlobalSearchApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     * List the courses a global search can be scoped to
     * Returns every course the user has access to, active and past, with an active flag.
     */
    getCourseFilterOptions(): Observable<Array<CourseForSearchFilter>> {
        const url = `${this.basePath}/api/search/course-options`;
        return this.http.get<Array<CourseForSearchFilter>>(url);
    }

    /**
     * Perform a unified semantic search across entity types
     * Searches across multiple entity types (exercises, lectures, lecture units, exams, FAQs, channels, courses) with a consistent response format. Messages and replies are not searchable; the types post and answer_post are accepted for compatibility but match nothing. When courseIds is not specified, the search is performed globally across all courses the authenticated user has access to. Per-type access rules are enforced server-side via compound Weaviate filters.
     * @param q Search query; can be empty to retrieve recent items
     * @param types Comma-separated entity type filter (exercise, lecture, lecture_unit, exam, faq, channel, course) or \&#39;all\&#39;; default \&#39;all\&#39;. post and answer_post are accepted but match nothing
     * @param excludeTypes Comma-separated entity types to hide from the results; applied after \&#39;types\&#39;
     * @param courseIds Course IDs to restrict the search to one or more courses (OR); inaccessible IDs are ignored
     * @param excludeCourseIds Course IDs to exclude from the search; results in these courses are hidden
     * @param limit Maximum number of results (1–25, default 10)
     * @param courseId Deprecated, use courseIds. A single course ID, still honored for clients that predate courseIds
     */
    globalSearch(q: string, types?: string, excludeTypes?: string, courseIds?: Array<number>, excludeCourseIds?: Array<number>, limit?: number, courseId?: number): Observable<Array<GlobalSearchResult>> {
        const queryParams = new URLSearchParams();
        appendQueryParam(queryParams, 'q', q);
        appendQueryParam(queryParams, 'types', types);
        appendQueryParam(queryParams, 'excludeTypes', excludeTypes);
        appendQueryParam(queryParams, 'courseIds', courseIds);
        appendQueryParam(queryParams, 'excludeCourseIds', excludeCourseIds);
        appendQueryParam(queryParams, 'limit', limit);
        appendQueryParam(queryParams, 'courseId', courseId);
        const queryString = queryParams.toString();
        const url = `${this.basePath}/api/search${queryString ? `?${queryString}` : ''}`;
        return this.http.get<Array<GlobalSearchResult>>(url);
    }

}
